import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import LinkItem from './LinkItem';
import SearchBar from './SearchBar';
import grupoIcon from '../assets/img/grupo.svg';
import { debounce } from 'lodash';

const LinkList = () => {
  const [links, setLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Link fixo
  const fixedLinks = [
    {
      id: 'fixed-1',
      title: 'ACESSAR GRUPO DE PROMOÇÕES',
      url: 'https://farejando.promo/grupo',
      thumb: grupoIcon,
      key: 'ENTRAR', // Mantém a chave se necessário
    },
  ];

  // Busca os links do Firestore
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'links'));
        const linksData = querySnapshot.docs
          .map((doc) => {
            const data = doc.data();
            // Garante que os campos essenciais existem
            if (data.title && data.url && data.thumb && data.key) {
              return { id: doc.id, ...data };
            }
            console.warn('Documento inválido encontrado:', doc.id, data); // Log para identificar documentos incompletos
            return null;
          })
          .filter((link) => link !== null);

        // Ordena por título
        const sortedLinks = linksData.sort((a, b) =>
          a.title.localeCompare(b.title)
        );

        setLinks(sortedLinks);
        setFilteredLinks(sortedLinks); // Inicialmente exibe todos os links
      } catch (error) {
        console.error('Erro ao buscar links:', error);
        setError('Erro ao carregar os links. Tente novamente mais tarde.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchLinks();
  }, []); // Dependência vazia para rodar apenas uma vez ao montar o componente

  // Função de busca com debounce - LÓGICA MELHORADA
  const handleSearch = debounce((term) => {
    setSearchTerm(term);
    const searchLower = term.toLowerCase().trim(); // Converte para minúsculas e remove espaços extras

    // Se o termo de busca estiver vazio, mostra todos os links
    if (!searchLower) {
      setFilteredLinks(links);
      return;
    }

    // Verifica se o termo de busca parece um código (começa com # ou é puramente numérico)
    const isCodeSearch = searchLower.startsWith('#') || /^\d+$/.test(searchLower);
    const codeToMatch = isCodeSearch ? searchLower.replace('#', '') : null; // Remove o '#' se presente

    const filtered = links.filter((link) => {
      const linkKeyLower = link.key ? String(link.key).toLowerCase().trim() : ''; // Garante que key é string e limpa
      const linkTitleLower = link.title ? String(link.title).toLowerCase().trim() : ''; // Garante que title é string e limpa

      if (isCodeSearch && codeToMatch) {
        // Se for uma busca por código (#... ou número puro), busca por correspondência EXATA na chave
        return linkKeyLower === codeToMatch;
      } else {
        // Se não for uma busca por código, mantém a busca original (menos rigorosa)
        // Busca por substring no título OU na chave
        return linkTitleLower.includes(searchLower) || linkKeyLower.includes(searchLower);
      }
    });

    setFilteredLinks(filtered);
  }, 300); // 300ms de debounce

  // Limpa o debounce na desmontagem do componente para evitar vazamento de memória
  useEffect(() => {
    return () => {
      handleSearch.cancel(); // Cancela qualquer chamada debounce pendente
    };
  }, [handleSearch]); // Depende da função handleSearch (que é estável por causa do debounce)


  if (isLoading) {
    return <p>Carregando links...</p>;
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div className="link-list">
      {/* Passa a função de busca para a SearchBar */}
      <SearchBar onSearch={handleSearch} />

      {/* Renderiza o link fixo */}
      {fixedLinks.map((link) => (
        <LinkItem
          key={link.id}
          id={link.id}
          title={link.title}
          url={link.url}
          thumb={link.thumb}
          linkKey={link.key} // Passa a chave para o LinkItem
        />
      ))}

      {/* Renderiza os links dinâmicos filtrados */}
      {filteredLinks.length === 0 ? (
        <p className="no-results">Nenhum resultado encontrado.</p>
      ) : (
        filteredLinks.map((link) => (
          <LinkItem
            key={link.id}
            id={link.id}
            title={link.title}
            url={link.url}
            thumb={link.thumb}
            linkKey={link.key} // Passa a chave para o LinkItem
          />
        ))
      )}
    </div>
  );
};

export default LinkList;
